import React from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  Typography,
  makeStyles
} from '@material-ui/core'

const useStyles = makeStyles(() => ({
  paper: {
    minWidth: 320,
    maxWidth: 380
  },
  title: {
    paddingBottom: 4
  },
  subtitle: {
    fontSize: 12,
    color: 'var(--color-neutral-500, #888)',
    marginBottom: 12
  },
  progress: {
    borderRadius: 4,
    height: 6,
    marginBottom: 8
  },
  rowCount: {
    fontSize: 12,
    color: 'var(--color-neutral-600, #666)',
    textAlign: 'right'
  }
}))

export default function LazyExpandDialog ({ open, state, onCancel }) {
  const classes = useStyles()

  if (!state) return null

  const { currentLevel, totalLevels, completedRows, totalRows } = state
  const pct = totalRows > 0 ? Math.round((completedRows / totalRows) * 100) : 0

  return (
    <Dialog
      open={open}
      disableBackdropClick // MUI v5: replace with onClose reason check
      disableEscapeKeyDown
      classes={{ paper: classes.paper }}
    >
      <DialogTitle className={classes.title}>
        Expanding...
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.subtitle}>
          Level {currentLevel} of {totalLevels}
        </Typography>
        <LinearProgress
          className={classes.progress}
          variant={totalRows > 0 ? 'determinate' : 'indeterminate'}
          value={pct}
        />
        <Typography className={classes.rowCount}>
          {completedRows} of {totalRows} rows loaded
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} size='small'>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

LazyExpandDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  state: PropTypes.shape({
    targetLevelName: PropTypes.string,
    currentLevel: PropTypes.number,
    totalLevels: PropTypes.number,
    completedRows: PropTypes.number,
    totalRows: PropTypes.number
  }),
  onCancel: PropTypes.func.isRequired
}
